import { render, staticRenderFns } from "./r-info.vue?vue&type=template&id=3d345006&scoped=true"
import script from "./r-info.vue?vue&type=script&setup=true&lang=js"
export * from "./r-info.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-info.vue?vue&type=style&index=0&id=3d345006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d345006",
  null
  
)

export default component.exports